import {
  registerComponent,
  getComponentConfig,
  loading,
  asyncRequest,
} from "helpers";

registerComponent(
  "swatch-link",
  class SwatchLink extends HTMLElement {
    constructor() {
      super();

      this.config = getComponentConfig(this);
      this.productSummary = this.closest(".product-summary");
      this.productMedia = this.productSummary.querySelector(
        ".product-summary__media"
      );
      this.link = this.querySelector("a");

      this.link.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();

      // Stop all videos when swatch variant changes
      setTimeout(() => {
        this.stopAllVideos();
      }, 100);

      loading.add(this.productMedia);

      this.getProductSummary();
    }

    // Method to stop all video players when swatch variant changes
    stopAllVideos() {
      console.log('Stopping videos due to swatch variant change...');
      
      // Use the global stopAllVideos function
      if (typeof window.stopAllVideos === 'function') {
        window.stopAllVideos();
      } else {
        // Fallback: Use the global allVideoPlayers array from video-player.js
        if (typeof allVideoPlayers !== 'undefined') {
          console.log('Found video players in global array:', allVideoPlayers.length);
          
          allVideoPlayers.forEach(player => {
            if (player.iframe) {
              console.log('Stopping video player:', player);
              player.stopVideo();
            }
          });
        }
        
        // Fallback: Find all video player instances and stop them
        const videoPlayers = document.querySelectorAll('video-player');
        console.log('Found video players via querySelector:', videoPlayers.length);
        
        videoPlayers.forEach(player => {
          if (player.iframe) {
            console.log('Stopping video player:', player);
            player.stopVideo();
          }
        });
        
        // Also try to stop videos by removing iframes directly
        const iframes = document.querySelectorAll('video-player iframe');
        iframes.forEach(iframe => {
          console.log('Removing iframe directly:', iframe);
          iframe.remove();
        });
        
        // Remove video-player--playing class from all video players
        const playingVideos = document.querySelectorAll('video-player.video-player--playing');
        playingVideos.forEach(video => {
          console.log('Removing playing class from:', video);
          video.classList.remove('video-player--playing');
        });
      }
    }

    async getProductSummary() {
      const response = await asyncRequest(`${this.config.url}&view=summary`);

      if (response) {
        this.handleSuccessfulUpdate(response);
      } else {
        window.location.href = this.config.url;
      }
    }

    handleSuccessfulUpdate(html) {
      this.productSummary.outerHTML = html;
    }
  }
);
